export default [
  {
    path: '/layout',
    name: 'layout',
    component: () => import('../../views/layout/layout.vue'),
    meta: {
      pageTitle: 'Video Section Layout',
      breadcrumbs: ['Videos','Layout'],
    },
    children: [
      {
        path: '',
        name: 'layout-builder',
        component: () => import('../../views/layout/builder.vue')
      }
    ]
  }
]
